import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
} from "../../../util/varios";
import "react-tabs/style/react-tabs.css";
import TablaDeudasEjidos from "./tablaDeudaEjidos";
import TablaHistoricosEjidos from "./tabaHistoricoEjidos";
import { CatalagoInmo2 } from "../../../catalogos/catalogoRentasInm";
import axios from "axios";
import { Input, Radio, SearchInput, Select, Textarea } from "../../../ui/inputs/Input";
import { InfoButton } from "../../../ui/buttons/Button";

export const RegistroAseoUrbano = (props) => {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mPagar, setMPagar] = useState(0);
  const [cat, setCat] = useState(1);
  const [anio, setAnio] = useState([]);
  const [tipopersona, setTipoPersona] = useState(4);
  const [status, setStatus] = useState(0);
  const [desabiltar, setDesabilitar] = useState();
  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const btnCancela = useRef();
  const txtRitm = useRef();
  const txtDirecI = useRef();
  const txtCodCats = useRef();
  const txtTipoRenta = useRef();
  const txtCheckInmueble = useRef();
  const txtTipoContri = useRef();
  const txtTipoActividad = useRef();
  const txtCheckComercio = useRef();
  const txtCodCon = useRef();
  const txtCheckNatural = useRef();
  const txtCheckJuridico = useRef();
  const txtRazonS = useRef();
  const cmbCedRif = useRef();
  const txtCedRif = useRef();
  const txtTlf = useRef();
  const txtDirecI2 = useRef();
  const txtActivP = useRef();
  const txtClasificador = useRef();
  const txtid = useRef();
  const txtActivo = useRef();
  const txtInactivo = useRef();
  const txtMontoPagar = useRef(null);
  const txtHasta = useRef();
  const txtDesde = useRef();
  const [tecla, setTecla] = useState();
  const txtAñoDeuda = useRef();
  const [factorCambio, setFactorCambio] = useState(0);
  const [deuda, setDeuda] = useState();
  const [desde1, setDesde1] = useState(0);
  const [desde2, setDesde2] = useState(0);

  const handleInputMonto = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.which === 13) {
        if (event.target.id === "montoPagar") {
          txtMontoPagar.current.focus();
        }
      }

      console.log(event.target.value);
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const validarCamposDeuda = (event) => {
    event.preventDefault();
    var sigue = true;
    if (operacion === 2) {
      if (txtAñoDeuda.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar el Año para cargar la Deuda",
          icono: "informacion",
        });
        txtAñoDeuda.current.focus();
        sigue = false;
      } else if (
        txtDesde.current.value === "" ||
        txtHasta.current.value === ""
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar el periodo de inicio y final",
          icono: "informacion",
        });
        txtDesde.current.focus();
        sigue = false;
      } else if (
        parseInt(txtDesde.current.value) > parseInt(txtHasta.current.value)
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "La Fecha de inicio no puede ser mayor a la fecha final",
          icono: "informacion",
        });
        txtDesde.current.value = "";
        txtHasta.current.value = "";
        txtDesde.current.focus();
        sigue = false;
      } else if (
        txtMontoPagar.current.value === "" ||
        txtMontoPagar.current.value === "0,00"
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar un monto para la deuda",
          icono: "informacion",
        });
        txtMontoPagar.current.focus();
        sigue = false;
      } else if (sigue) {
        actualizarDeuda();
      }
    }
  };
  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

    if (
      mensaje.texto == "registro creado correctamente." ||
      mensaje.texto == "registro modificado correctamente." ||
      mensaje.texto == "registro eliminado correctamente."
    ) {
      blanquear();
      props.onHideCancela();
    }

    if (mensaje.texto === "Deuda Cargada") {
      //props.onHideRenderizar2(props.inmobiliaria);
      props.onHideRenderizar();
      /*txtAñoDeuda.current.value = "";
       txtDesde.current.value = "";
       txtHasta.current.value = "";
       txtMontoPagar.current.value = "";*/
    }
  };
  const handleChangeTipoPersona = (event) => {
    if (event.target.value === "0") {
      setTipoPersona(0);
      txtCheckNatural.current.checked = true;
      txtCheckJuridico.current.checked = false;
    } else {
      setTipoPersona(1);
      txtCheckNatural.current.checked = false;
      txtCheckJuridico.current.checked = true;
    }
  };
  const salir = () => {
    props.onHideCancela();
    blanquear();
  };
  const blanquear = () => {
    setActivate(false);
    setDeuda();
    setDesde1(0);
    setDesde2(0);
    setTipoPersona(4);
    setMPagar(0);
    txtCodCats.current.value = " ";
    txtDirecI.current.value = " ";
    txtDirecI2.current.value = " ";
    txtRazonS.current.value = " ";
    txtCedRif.current.value = " ";
    txtTlf.current.value = " ";
    txtTipoRenta.current.value = "";
    txtClasificador.current.value = "";
  };
  const onChange = (event) => {
    if (event.target.name === "clasificador" && operacion === 2) {
      const selectedIndex = txtClasificador.current.selectedIndex;
      let monto = "0,00";
      if (selectedIndex > 0) {
        monto = JSON.stringify(
          props.clasificador[selectedIndex - 1].monto
            .toString()
            .replace('"', "")
        );
      }
      /*let monto = JSON.stringify(props.clasificador[selectedIndex].monto.toString().replace('"', ''))*/

      console.log(parseFloat(monto.toString().replace(/"/g, "")));

      ///let tot = parseFloat(monto.toString().replace(/"/g, '')) * parseFloat(props.factorCambio);
      let tot = parseFloat(monto.toString().replace(/"/g, ""));

      console.log(tot);
      setMPagar(tot);
      if (txtMontoPagar.current) {
        txtMontoPagar.current.value = formatMoneda(
          tot.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
      }
    }
    if (
      event.target.name === "razonS" ||
      event.target.name === "directInm" ||
      event.target.name === "actP" ||
      event.target.name === "ritm" ||
      event.target.name === "codCon" ||
      event.target.name === "codCats" ||
      event.target.name === "directInm" ||
      event.target.name === "directInm2" ||
      event.target.name === "actividadP"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }

    if (event.target.name === "anioDeuda") {
      let nan = event.target.value;
    }

    if (event.target.name === "selectDesde") {
      let nan = event.target.value;
    }

    if (event.target.name === "selectHasta") {
      let nan = event.target.value;
    }

    if (event.target.name === "clasificador") {
      txtClasificador.current.value = event.target.value;
    }

    if (event.target.value === "tab2") {
    }
  };
  const validarContribuyente = (event) => {
    validaSoloNumero(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        if (cat === 1) {
          onKeyUpInm(event.target.value);
        } else {
          onKeyUpComr(event.target.value);
        }
      }
    } else {
      txtCodCats.current.value = "";
      txtDirecI.current.value = "";
      txtDirecI2.current.value = "";
      txtRazonS.current.value = "";
      if (tipopersona === 0) {
        cmbCedRif.current.value = "V";
      } else {
        cmbCedRif.current.value = "J";
      }
      txtCedRif.current.value = "";
      txtRitm.current.value = "";
      //txtDesde.current.value = "";
      //txtHasta.current.value = "";
      txtTlf.current.value = "";
      txtTipoActividad.current.value = "";
    }
  };
  const handleAceptaInmueble = (
    id,
    ritm,
    nombR,
    cedrif,
    areaC,
    areaT,
    usoInm,
    fechAvalu,
    codicatas,
    direct,
    direct2,
    valor,
    usoI,
    tlf
  ) => {
    setMostrar5(false);

    if (parseInt(cat) === 1) {
      txtCodCon.current.value = id;
      if (codicatas !== null) {
        txtCodCats.current.value =
          codicatas.substring(0, 2) +
          "-" +
          codicatas.substring(2, 4) +
          "-" +
          codicatas.substring(4, 6) +
          "-" +
          codicatas.substring(6, 7) +
          "-" +
          codicatas.substring(7, 9) +
          "-" +
          codicatas.substring(9, 12) +
          "-" +
          codicatas.substring(12, 15) +
          "-" +
          codicatas.substring(15, 18) +
          "-" +
          codicatas.substring(18, 21) +
          "-" +
          codicatas.substring(21, 24) +
          "-" +
          codicatas.substring(24, 27);
      } else {
        txtCodCats.current.value = "";
      }

      txtDirecI.current.value = direct;
      // txtDirecI2.current.value = direct2;
      //txtRazonS.current.value = nombR;
      //txtCedRif.current.value = cedrif;
    } else {
      txtCodCon.current.value = id;
      if (codicatas !== null) {
        txtCodCats.current.value =
          codicatas.substring(0, 2) +
          "-" +
          codicatas.substring(2, 4) +
          "-" +
          codicatas.substring(4, 6) +
          "-" +
          codicatas.substring(6, 7) +
          "-" +
          codicatas.substring(7, 9) +
          "-" +
          codicatas.substring(9, 12) +
          "-" +
          codicatas.substring(12, 15) +
          "-" +
          codicatas.substring(15, 18) +
          "-" +
          codicatas.substring(18, 21) +
          "-" +
          codicatas.substring(21, 24) +
          "-" +
          codicatas.substring(24, 27);
      } else {
        txtCodCats.current.value = "";
      }
      txtDirecI.current.value = direct;
      txtDirecI2.current.value = direct;
      txtRazonS.current.value = nombR;
      let letra = "";
      let pos = 0;
      let tipo = 0;
      if (
        cedrif.toUpperCase().charCodeAt(0) > 64 &&
        cedrif.toUpperCase().charCodeAt(0) < 91
      ) {
        letra = cedrif.substring(0, 1);
        pos = 1;
        if (letra === "V" || letra === "E") {
          tipo = 0;
        } else {
          tipo = 1;
        }
      } else {
        tipo = 1;
        letra = "J";
        pos = 0;
      }
      setTipoPersona(tipo);
      if (tipo === 0) {
        txtCheckNatural.current.checked = true;
        txtCheckJuridico.current.checked = false;
      } else {
        txtCheckNatural.current.checked = false;
        txtCheckJuridico.current.checked = true;
      }

      cmbCedRif.current.value = letra;
      txtCedRif.current.value = cedrif.substring(pos, cedrif.trim().length);
      txtTlf.current.value = tlf;
    }
  };
  const onKeyUpInm = (idinmueble) => {
    let campos = "*";
    let nomtab = "inmueble";
    let nomid = "idinmueble";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtCodCats.current.value =
              response.data.codigocatastral.substring(0, 2) +
              "-" +
              response.data.codigocatastral.substring(2, 4) +
              "-" +
              response.data.codigocatastral.substring(4, 6) +
              "-" +
              response.data.codigocatastral.substring(6, 7) +
              "-" +
              response.data.codigocatastral.substring(7, 9) +
              "-" +
              response.data.codigocatastral.substring(9, 12) +
              "-" +
              response.data.codigocatastral.substring(12, 15) +
              "-" +
              response.data.codigocatastral.substring(15, 18) +
              "-" +
              response.data.codigocatastral.substring(18, 21) +
              "-" +
              response.data.codigocatastral.substring(21, 24) +
              "-" +
              response.data.codigocatastral.substring(24, 27);

            txtDirecI.current.value =
              response.data.dirinmue1 !== null
                ? response.data.dirinmue1.trim() + ": "
                : "" + response.data.descridirinmue1 !== null
                  ? response.data.descridirinmue1.trim() + ", "
                  : "" + response.data.dirinmue5 !== null
                    ? response.data.dirinmue5.trim() + ": "
                    : "" + response.data.descridirinmue2 !== null
                      ? response.data.descridirinmue2.trim() + ", "
                      : "" + response.data.ciudadocupante !== null
                        ? response.data.ciudadocupante.trim()
                        : "";
            setActivate(false);
          } else {
            txtCodCon.current.value = "";
            if (tecla === 13) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Inmueble no existe.",
                icono: "error",
              });
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };
  const onKeyUpComr = (idcomercio) => {
    let campos = "*";
    let nomtab = "comercio";
    let nomid = "idcomercio";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idcomercio}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtCodCats.current.value = "";
            txtDirecI.current.value = response.data.direccion;
            txtDirecI2.current.value = response.data.direccion;
            txtRazonS.current.value = response.data.nombre;
            let letra = "";
            let pos = 0;
            let tipo = 0;
            if (
              response.data.rif.toUpperCase().charCodeAt(0) > 64 &&
              response.data.rif.toUpperCase().charCodeAt(0) < 91
            ) {
              letra = response.data.rif.substring(0, 1);
              pos = 1;
              if (letra === "V" || letra === "E") {
                tipo = 0;
              } else {
                tipo = 1;
              }
            } else {
              tipo = 1;
              letra = "J";
              pos = 0;
            }
            setTipoPersona(tipo);
            if (tipo === 0) {
              txtCheckNatural.current.checked = true;
              txtCheckJuridico.current.checked = false;
            } else {
              txtCheckNatural.current.checked = false;
              txtCheckJuridico.current.checked = true;
            }

            cmbCedRif.current.value = letra;
            txtCedRif.current.value = response.data.rif.substring(
              pos,
              response.data.rif.trim().length
            );

            txtTlf.current.value = response.data.telefono;
            //txtActivP.current.value = response.data.tipoactividad;
            setActivate(false);
          } else {
            txtCodCon.current.value = "";
            if (tecla === 13) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Comercio no existe.",
                icono: "error",
              });
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };
  const tipoContri = (e) => {
    setCat(parseInt(e.target.value));
    console.log(e.target.value);
    txtCodCon.current.value = "";
    txtCodCats.current.value = "";
    txtDirecI.current.value = "";
    txtDirecI2.current.value = "";
    txtRazonS.current.value = "";
    txtCedRif.current.value = "";

    txtRitm.current.value = "";
    /*txtDesde.current.value = "";
    txtHasta.current.value = "";*/
    txtTlf.current.value = "";
  };
  const actualizarDeuda = () => {
    let endpoint = "";
    let body;
    if (espiritu === 0) {
      endpoint = `${op.conexion}/api/aseo/creardeudarenta`;
      body = {
        operacion: 1,
        id: parseInt(
          props.inmobiliaria
            ? props.inmobiliaria.idrentas !== null
              ? props.inmobiliaria.idrentas.trim()
              : ""
            : ""
        ),
        nomtab: "deudarentas",
        nomid: "idrentas",
        peri: props.periodoPagoR,
        //monto: parseFloat(
        //txtMontoPagar.current.value.replace(/\./g, "").replace(",", ".") /
        //props.periodoR /
        //props.valorUT,
        //4
        //),
        monto: parseFloat(
          txtMontoPagar.current.value.replace(/\./g, "").replace(",", "."),
          4
        ),
        nanio: parseInt(txtAñoDeuda.current.value),
        mesdesde: parseInt(txtDesde.current.value),
        meshasta: parseInt(txtHasta.current.value),
        nomiddeu: "iddeudarentas",
        tipo: 0,
      };
    } else {
      endpoint = `${op.conexion}/api/aseo/creardeudarenta1`;
      body = {
        operacion: 1,
        id: parseInt(
          props.inmobiliaria
            ? props.inmobiliaria.idrentas !== null
              ? props.inmobiliaria.idrentas.trim()
              : ""
            : ""
        ),
        nomtab: "deudarentas",
        monto: parseFloat(
          txtMontoPagar.current.value.replace(/\./g, "").replace(",", "."),
          4
        ),
        nanio: parseInt(txtAñoDeuda.current.value),
        mesdesde: parseInt(txtDesde.current.value),
        meshasta: parseInt(txtHasta.current.value),
        peri: props.periodoPagoR,
      };
    }

    //let endpoint = `${op.conexion}/api/aseo/creardeudarenta1`;

    console.log(body);

    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setActivate(false);

          setDesde1(1);
          SelectDeudaC(txtid.current.value);
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Deuda Cargada",
            icono: "exito",
          });
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };
  const opcionesRegistro = (e) => {
    e.preventDefault();
    var sigue = true;
    if (operacion !== 4) {
      if (txtTipoRenta.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar un tipo de Renta",
          icono: "informacion",
        });

        txtTipoRenta.current.focus();

        sigue = false;
      } else if (txtCodCon.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: 'Debe seleccionar un contribuyente con el Boton "BUSCAR"',
          icono: "informacion",
        });

        txtCodCon.current.focus();

        sigue = false;
      } else if (
        !txtCheckJuridico.current.checked &&
        !txtCheckNatural.current.checked
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar si es Prs.Natural o Prs.Juridica",
          icono: "informacion",
        });

        txtCheckJuridico.current.focus();

        sigue = false;
      } else if (cmbCedRif.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar la Letra de la Cedula o Rif",
          icono: "informacion",
        });

        cmbCedRif.current.focus();
        sigue = false;
      } else if (txtCedRif.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar el Número de Cedula o Rif",
          icono: "informacion",
        });

        txtCedRif.current.focus();
        sigue = false;
      } else if (txtTlf.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar un Número de Telefono Valido",
          icono: "informacion",
        });

        txtTlf.current.value = "";
        txtTlf.current.focus();
        sigue = false;
      } else if (txtRazonS.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar el Nombre o Razon Social",
          icono: "informacion",
        });

        txtRazonS.current.focus();
        sigue = false;
      } else if (txtDirecI2.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar la Dirección",
          icono: "informacion",
        });

        txtDirecI2.current.focus();
        sigue = false;
      } else if (txtTipoActividad.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar la Actividad Principal",
          icono: "informacion",
        });

        txtTipoActividad.current.focus();
        sigue = false;
      } else if (txtClasificador.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar una Clasificacion",
          icono: "informacion",
        });

        sigue = false;
      } else if (sigue === true) {
        actualizarRenta(props.operacion);
      }
    }
  };
  const actualizarRenta = (operacion) => {
    let endpoint = `${op.conexion}/api/aseo/createaseo/${operacion}`;
    let body;
    setActivate(true);

    // Safely get montoPagar value
    let montoPagarValue = 0;

    if (props.operacion === 1) {
      // For new registrations, use mPagar state
      montoPagarValue = mPagar;
    } else {
      // For edits, try to get from ref if it exists, otherwise use props
      if (txtMontoPagar.current) {
        montoPagarValue = txtMontoPagar.current.value === ""
          ? 0
          : parseFloat(txtMontoPagar.current.value.replace(/\./g, "").replace(",", "."));
      } else if (props.inmobiliaria && props.inmobiliaria.montoarrendamiento) {
        montoPagarValue = props.inmobiliaria.montoarrendamiento;
      }
    }

    body = {
      nid: parseInt(txtid.current.value),
      idinmue: parseInt(txtCodCon.current.value),
      numcontra: null,
      feccontra: null,
      idTipren: txtTipoRenta.current.value,
      tipper: txtCheckNatural.current.checked
        ? 0
        : txtCheckJuridico.current.checked
          ? 1
          : null,
      nomarren: txtRazonS.current.value,
      dire: txtDirecI2.current.value === "" ? null : txtDirecI2.current.value,
      ced:
        txtCedRif.current.value === ""
          ? null
          : cmbCedRif.current.value + txtCedRif.current.value,
      tlf: txtTlf.current.value,
      fecini: null,
      fecfin: null,
      monarren: montoPagarValue,
      tiparren: null,
      pericance: null,
      duracont: null,
      tiploc: null,
      numloc: null,
      tipacti:
        txtTipoActividad.current.value == ""
          ? null
          : txtTipoActividad.current.value,
      codimpu: parseInt(
        JSON.stringify(
          props.rentas[txtTipoRenta.current.selectedIndex].codigoimpuesto
        )
      ),
      nritm: txtRitm.current.value,
      tiptab: cat,
      clasif: txtClasificador.current.value,
      sta: status,
      moti: null,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          props.onHideRenderizar();

          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente.",
              icono: "exito",
            });
            console.log(body);
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente.",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response ? error.response.data.message : "Error en la conexión",
          icono: "error",
        });
        setActivate(false);
      });
  };
  useEffect(() => {
    let anioact = JSON.parse(localStorage.getItem("efiscalanio"));
    var nanio = [];
    var aini = parseInt(anioact) - 7;
    var afin = parseInt(anioact);

    for (let i = 0; i + aini <= afin; i++) {
      nanio.push({ anio: afin - i });
    }
    setAnio(nanio);

    setDesabilitar(false);
  }, []);

  useEffect(() => {
    if (
      props.operacion !== 1 &&
      props.inmobiliaria &&
      props.inmobiliaria.tipopersona <= 1
    ) {
      let letra = "";
      let pos = 0;
      let tipo = 4;
      if (desde2 === 0) {
        tipo = props.inmobiliaria.tipopersona;
        if (
          props.inmobiliaria.cedrif.toUpperCase().charCodeAt(0) > 64 &&
          props.inmobiliaria.cedrif.toUpperCase().charCodeAt(0) < 91
        ) {
          letra = props.inmobiliaria.cedrif.substring(0, 1);
          pos = 1;
        } else {
          if (tipo === 0) {
            letra = "V";
          } else {
            letra = "J";
          }
          pos = 0;
        }

        cmbCedRif.current.value = letra;
        txtCedRif.current.value = props.inmobiliaria.cedrif.substring(
          pos,
          props.inmobiliaria.cedrif.trim().length
        );
      } else {
        tipo = tipopersona;
        cmbCedRif.current.value = "";
      }
      setDesde2(1);
    }
  }, [tipopersona]);
  const verificar = () => {
    txtCodCon.current.value = " ";
    txtRitm.current.value = "";
    txtCodCats.current.value = " ";
    txtDirecI.current.value = " ";
    txtDirecI2.current.value = " ";
    txtRazonS.current.value = " ";
    txtCedRif.current.value = " ";
    txtTlf.current.value = " ";
    //txtTipoRenta.current.value = "";
    txtCheckNatural.current.checked = false;
    txtCheckJuridico.current.checked = false;

    setDesabilitar(false);
    setMostrar5(true);
  };
  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.id === "inputTlf") {
        txtTlf.current.value.toString().trim().padStart(2, 0);

        if (event.which === 13) {
          txtTlf.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  const SelectDeudaC = (idrentas) => {
    let tabla = "aseo";
    let endpoint = "";
    if (espiritu === 0) {
      endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
    } else {
      //endpoint = `${op.conexion}/api/aseo/deudarenta1?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
      endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
    }
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log("Deuda");

          var deu = [];
          var his = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu * factorCambio,
                intereses: response.data[i].intmoradeu * factorCambio,
                multa: response.data[i].multa * factorCambio,
                recargo: response.data[i].recargodeu * factorCambio,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
              });
            }
          }

          setDeuda(deu);
          //setHistorico(his);
          setActivate(false);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      }); /* .finally(function () {
            setValido({ ...valido, sigue1: 1 });
        }) */
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setFactorCambio(props.factorCambio);
        setDesde1(0);
        setOperacion(props.operacion);
        setDesabilitar(false);
        if (props.operacion === 1) {
          txtCheckNatural.current.checked = true;
          txtCheckJuridico.current.checked = false;
        } else {
          setDesde2(0);
          setTipoPersona(props.inmobiliaria.tipopersona);
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Registrar Contribuyente Aseo Urbano."
            : operacion === 2
              ? "Editar Contribuyente Aseo Urbano."
              : operacion === 3
                ? "Eliminar Contribuyente Aseo Urbano."
                : "Consultar Contribuyente Aseo Urbano"}
        </h3>
        <a
          type="button"
          ref={btnCancela}
          className="fw-bold fs-6 text-light"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div>
          <ul className="nav mb-2" id="ex-with-icons" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link active bg-blue-100 text-light"
                id="datosTributarios"
                data-bs-toggle="tab"
                data-bs-target="#tributarios"
                type="button"
                role="tab"
                aria-controls="tributarios"
                aria-selected="true"
              >
                Datos Generales
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-200 text-light"
                disabled={operacion === 1 || operacion === 3 ? true : false}
                id="deuda-tab"
                data-bs-toggle="tab"
                data-bs-target="#deuda"
                type="button"
                role="tab"
                aria-controls="deuda"
                aria-selected="false"
              >
                Deudas del Contribuyente
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-300 text-light"
                disabled={operacion === 1 || operacion === 3 ? true : false}
                id="hist-tab"
                data-bs-toggle="tab"
                data-bs-target="#historico"
                type="button"
                role="tab"
                aria-controls="historico"
                aria-selected="false"
              >
                Historicos de Pagos
              </a>
            </li>
            <div className="input-group mr-0 input-group-sm mb-1 col-md-2">
              <span className="input-group-text bg-transparent fw-bold border-0">
                Valor Euro €:
              </span>
              <span className="input-group-text bg-transparent fw-bold border-0">
                {formatMoneda(
                  factorCambio.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                )}
              </span>
            </div>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="tributarios"
              role="tabpanel"
              aria-labelledby="datosTributarios"
            >
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <div className="col-2 m-0 mb-2 p-0">
                  <Input label='Código:'
                    ref={txtid}
                    disabled
                    defaultValue={
                      props.inmobiliaria
                        ? props.inmobiliaria.idrentas !== null
                          ? props.inmobiliaria.idrentas.trim()
                          : ""
                        : ""
                    }
                    id="inputCodigo"
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Select label='Tipo de Renta:'
                    name="idclasevehiculo"
                    ref={txtTipoRenta}
                    disabled={operacion === 1 ? false : true}
                    value={props.inmobiliaria && props.inmobiliaria.idtiporenta}
                    id="inputTP"
                  >
                    {props.rentas &&
                      props.rentas.map((item, index) => (
                        <option key={index} value={item.idtiporentas}>
                          {" "}
                          {item.descripcion}{" "}
                        </option>
                      ))}
                  </Select>
                </div>
                <div className="col-2 m-0 mb-2 p-0 pl-2">
                  <Input label='RITM:'
                    ref={txtRitm}
                    disabled
                    defaultValue={
                      props.inmobiliaria
                        ? props.inmobiliaria.ritm !== null
                          ? props.inmobiliaria.ritm.trim()
                          : ""
                        : ""
                    }
                    id="ritm"
                    name="ritm"
                    onChange={onChange}
                  />
                </div>
                <div className="col-2 m-0 mb-2 p-0 pl-2">
                  <SearchInput label='Cod. Comtrib:'
                    ref={txtCodCon}
                    disabled={operacion === 1 ? false : true}
                    defaultValue={
                      props.inmobiliaria
                        ? props.inmobiliaria.idinmueble !== null
                          ? props.inmobiliaria.idinmueble.trim()
                          : ""
                        : ""
                    }
                    id="codCon"
                    name="codCon"
                    onChange={onChange}
                    onKeyUp={validarContribuyente}
                    onBlur={validarContribuyente}
                    onClickButton={verificar}
                    disabledButton={operacion === 1 ? false : true}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Select label='Tipo de Contribuyente:'
                    name="idclasevehiculo"
                    ref={txtTipoContri}
                    disabled={operacion === 1 ? false : true}
                    defaultValue={
                      props.inmobiliaria && props.inmobiliaria.tipotabla
                    }
                    onChange={tipoContri}
                    id="inputTP"
                  >
                    <option value="1">Inmueble</option>
                    <option value="0">Comercio</option>
                  </Select>
                </div>
                <div className="col-3 m-0 p-0">
                  <Input label='Código Catastral:'
                    disabled
                    ref={txtCodCats}
                    defaultValue={
                      props.inmueble
                        ? props.inmueble.codigocatastral !== null
                          ? props.inmueble.codigocatastral
                            .trim()
                            .substring(0, 2) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(2, 4) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(4, 6) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(6, 7) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(7, 9) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(9, 12) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(12, 15) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(15, 18) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(18, 21) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(21, 24) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(24, 27)
                          : ""
                        : ""
                    }
                    id="codCats"
                    name="codCats"
                    onChange={onChange}
                  />
                </div>
                <div className="col-9 m-0 p-0 pl-2">
                  <Input label='Dirección del Inmueble:'
                    disabled
                    ref={txtDirecI}
                    defaultValue={
                      props.inmobiliaria
                        ? props.inmobiliaria.direccion !== null
                          ? props.inmobiliaria.direccion.trim()
                          : ""
                        : ""
                    }
                    id="directInm"
                    name="directInm"
                    onChange={onChange}
                  />
                </div>
                {operacion !== 1 &&
                  <div className="col-12 m-0 mt-2 p-0 d-flex gap-2 align-items-center">
                    <span className="fw-bold">
                      Status:
                    </span>
                    <div className="col-auto m-0 p-0">
                      <Radio label='Activo'
                        ref={txtActivo}
                        disabled={operacion === 2 ? false : true}
                        name="checkStatus"
                        value={0}
                        defaultChecked={
                          props.inmobiliaria && props.inmobiliaria.status === 0
                        }
                        id="checkStatus"
                        onChange={(event) => setStatus(event.target.value)}
                      />
                    </div>

                    <div className="col-auto m-0 p-0">
                      <Radio label='Inactivo'
                        ref={txtInactivo}
                        disabled={operacion === 2 ? false : true}
                        name="checkStatus"
                        value={1}
                        defaultChecked={
                          props.inmobiliaria && props.inmobiliaria.status === 1
                        }
                        id="checkStatus"
                        onChange={(event) => setStatus(event.target.value)}
                      />
                    </div>
                  </div>
                }
                <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                  <legend className="float-none w-auto">
                    Datos del Arrendatario
                  </legend>
                  <div className="col-6 m-0 mb-2 p-0 d-flex gap-2 align-items-center">
                    <span className="fw-bold">
                      Tipos de Contribuyentes
                    </span>
                    <div className="col-auto m-0 p-0">
                      <Radio label='Prs. Natural'
                        ref={txtCheckNatural}
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        name="radioPers"
                        value={"0"}
                        defaultChecked={
                          props.inmobiliaria &&
                          props.inmobiliaria.tipopersona === 0
                        }
                        id="radioPers"
                        onChange={handleChangeTipoPersona}
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio label='Prs. Jurídica'
                        ref={txtCheckJuridico}
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        name="radioPers"
                        value={"1"}
                        defaultChecked={
                          props.inmobiliaria &&
                          props.inmobiliaria.tipopersona === 1
                        }
                        id="radioPers2"
                        onChange={handleChangeTipoPersona}
                      />
                    </div>
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 d-flex align-items-center">
                    <div className="col-6 m-0 p-0">
                      {tipopersona === 0 ? (
                        <Select label='Cedula/Rif:'
                          ref={cmbCedRif}
                          id="inputCedRif"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                        >
                          <option value="V">V</option>
                          <option value="E">E</option>
                        </Select>
                      ) : (
                        <Select label='Cedula/Rif:'
                          ref={cmbCedRif}
                          id="inputCedRif"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                        >
                          <option value="J">J</option>
                          <option value="V">V</option>
                          <option value="G">G</option>
                        </Select>
                      )}
                    </div>
                    <Input
                      ref={txtCedRif}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      defaultValue={
                        props.inmobiliaria
                          ? props.inmobiliaria.cedrif !== null
                            ? props.inmobiliaria.cedrif.trim()
                            : ""
                          : ""
                      }
                      id="inputCodigo"
                    />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label='Telefono:'
                      ref={txtTlf}
                      minLength={11}
                      maxLength={11}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      defaultValue={
                        props.inmobiliaria
                          ? props.inmobiliaria.telefono !== null
                            ? props.inmobiliaria.telefono.trim()
                            : ""
                          : ""
                      }
                      id="inputTlf"
                      name="inputTlf"
                      onKeyUp={handleInputNumChange}
                      onBlur={handleInputNumChange}
                    />
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Input label='Nombre o Razon Social:'
                      ref={txtRazonS}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      defaultValue={
                        props.inmobiliaria
                          ? props.inmobiliaria.nombrearrendatario !== null
                            ? props.inmobiliaria.nombrearrendatario.trim()
                            : ""
                          : ""
                      }
                      id="razonS"
                      name="razonS"
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Textarea label='Dirección:'
                      style={{ height: 70 }}
                      ref={txtDirecI2}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      defaultValue={
                        props.inmobiliaria
                          ? props.inmobiliaria.direccion !== null
                            ? props.inmobiliaria.direccion.trim()
                            : ""
                          : ""
                      }
                      id="directInm2"
                      name="directInm2"
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-12 m-0 p-0">
                    <Textarea label='Tipo de Actividad:'
                      style={{ height: 70 }}
                      ref={txtTipoActividad}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      defaultValue={
                        props.inmobiliaria
                          ? props.inmobiliaria.tipoactividad !== null
                            ? props.inmobiliaria.tipoactividad.trim()
                            : ""
                          : ""
                      }
                      id="actividadP"
                      name="actividadP"
                      onChange={onChange}
                    />
                  </div>
                </fieldset>
                <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                  <legend className="float-none w-auto">
                    <label
                      className="form-check-label"
                      disabled={
                        operacion === 1
                          ? desabiltar
                          : operacion === 2
                            ? false
                            : true
                      }
                      htmlFor="inlineRadio2"
                    >
                      Información Inmueble
                    </label>
                  </legend>

                  <div className="col-6 m-0 mb-2 p-0">
                    <Select label='Tipo Clasificación:'
                      ref={txtClasificador}
                      disabled={
                        operacion === 1
                          ? false
                          : operacion === 2
                            ? false
                            : true
                      }
                      defaultValue={
                        props.inmobiliaria &&
                        props.inmobiliaria.idclasificador
                      }
                      onChange={onChange}
                      name="clasificador"
                    >
                      <option value="">Seleccionar</option>
                      {props.clasificador &&
                        props.clasificador.map((item, index) => (
                          <option key={index} value={item.idclaseaseo}>
                            {" "}
                            {item.descripcion}{" "}
                          </option>
                        ))}
                    </Select>
                  </div>
                  {operacion == 1 &&
                    <div className="col-12 m-0 p-0 d-flex align-items-center">
                      <div className="col-2 m-0 p-0">
                        <Select label='Año:'
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          ref={txtAñoDeuda}
                          name="anioDeuda"
                          onChange={onChange}
                        >
                          {anio &&
                            anio.map((a) => (
                              <option key={a.anio} value={a.anio}>
                                {a.anio}
                              </option>
                            ))}
                        </Select>
                      </div>

                      <div className="col-5 m-0 p-0 pl-2 d-flex gap-2 align-items-center">
                        <span className="fw-bold">
                          Periodos de Deuda:
                        </span>

                        <div className="col m-0 p-0">
                          <Select label='Desde:'
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            name="selectDesde"
                            ref={txtDesde}
                            onChange={onChange}
                          >
                            <option key="1" value={1}>
                              ENERO
                            </option>
                            <option key="2" value={2}>
                              FEBRERO
                            </option>
                            <option key="3" value={3}>
                              MARZO
                            </option>
                            <option key="4" value={4}>
                              ABRIL
                            </option>
                            <option key="5" value={5}>
                              MAYO
                            </option>
                            <option key="6" value={6}>
                              JUNIO
                            </option>
                            <option key="7" value={7}>
                              JULIO
                            </option>
                            <option key="8" value={8}>
                              AGOSTO
                            </option>
                            <option key="9" value={9}>
                              SEPTIEMBRE
                            </option>
                            <option key="10" value={10}>
                              OCTUBRE
                            </option>
                            <option key="11" value={11}>
                              NOVIEMBRE
                            </option>
                            <option key="12" value={12}>
                              DICIEMBRE
                            </option>
                          </Select>
                        </div>
                        <div className="col m-0 p-0">
                          <Select label='Hasta:'
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            name="selectHasta"
                            ref={txtHasta}
                            onChange={onChange}
                            defaultValue={"12"}
                          >
                            <option key="1" value="1">
                              ENERO
                            </option>
                            <option key="2" value="2">
                              FEBRERO
                            </option>
                            <option key="3" value="3">
                              MARZO
                            </option>
                            <option key="4" value="4">
                              ABRIL
                            </option>
                            <option key="5" value="5">
                              MAYO
                            </option>
                            <option key="6" value="6">
                              JUNIO
                            </option>
                            <option key="7" value="7">
                              JULIO
                            </option>
                            <option key="8" value="8">
                              AGOSTO
                            </option>
                            <option key="9" value="9">
                              SEPTIEMBRE
                            </option>
                            <option key="10" value="10">
                              OCTUBRE
                            </option>
                            <option key="11" value="11">
                              NOVIEMBRE
                            </option>
                            <option key="12" value="12">
                              DICIEMBRE
                            </option>
                          </Select>
                        </div>
                      </div>

                      <div className="col-5 m-0 p-0 d-flex pl-2">
                        <Input label='Monto a Pagar:'
                          ref={txtMontoPagar}
                          disabled
                          defaultValue={
                            props.inmobiliaria &&
                              props.inmobiliaria.montoarrendamiento
                              ? formatMoneda(
                                props.inmobiliaria.montoarrendamiento
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                              : "0,00"
                          }
                          id="montoPagar"
                          onKeyUp={handleInputMonto}
                          onBlur={handleInputMonto}
                        />
                        <div className="col-auto m-0 p-0 input-group-sm">
                          <InfoButton icon='m-0'
                            className='rounded-0 m-0'
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            onClick={validarCamposDeuda}
                          >
                            Cargar
                          </InfoButton>
                        </div>
                      </div>
                    </div>
                  }
                </fieldset>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="deuda"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              <div className="row col-md-12">
                <TablaDeudasEjidos
                  tabdeuda={desde1 === 0 ? props.deuda : deuda}
                  idrentas={props.inmobiliaria && props.inmobiliaria.idrentas}
                  visibleF={"hidden"}
                  credito={
                    props.credito && props.credito > 0 ? props.credito : 0.0
                  }
                />
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="historico"
              role="tabpanel"
              aria-labelledby="hist-tab"
            >
              <div className="row col-md-12">
                <TablaHistoricosEjidos
                  tabHis={props.historico}
                  idrentas={props.inmobiliaria && props.inmobiliaria.idrentas}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success col-md-1 rounded-pill"
          disabled={props.operacion === 4 ? true : false}
          onClick={opcionesRegistro}
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={salir}
          className="btn btn-sm btn-danger col-md-1 rounded-pill"
        >
          <i className="fas fa-window-close"> Salir</i>
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate}></Dimmer>
      <CatalagoInmo2
        show={mostrar5}
        onHideCancela={cerrarModalActualizar}
        cat={cat}
        onHideAceptaCatInm={handleAceptaInmueble}
      />
    </Modal>
  );
};
